import * as React from "react";
import { Flex, Spinner } from "@chakra-ui/react";
import { parseISO } from "date-fns";
import { PageHeader, Wrapper } from "components";
import { useNavigate, useParams, useToast } from "duck";
import { useGetOrderQuery, useUpdateOrderMutation } from "requests";
import Form from "../form";

const Edit: React.FC = () => {
  const toast = useToast({ status: "success" });
  const navigate = useNavigate();
  const { id } = useParams();
  const { data, loading } = useGetOrderQuery({
    variables: { id: +id },
    fetchPolicy: "no-cache"
  });

  const [updateOrder] = useUpdateOrderMutation({ ignoreResults: true });

  const defaultValues = data?.order
    ? {
        license: data.order.license._id,
        licensePeriod: data.order.license.period,
        price: data.order.price,
        organization: data.order.organization._id,
        startDate: parseISO(data.order.startDate),
        expirationDate: parseISO(data.order.expirationDate)
      }
    : null;

  return (
    <>
      <PageHeader title="Edit Order" backURL={-1} />
      <Wrapper mt={6}>
        {loading || !defaultValues ? (
          <Flex justifyContent="center">
            <Spinner />
          </Flex>
        ) : (
          <Form
            defaultValues={defaultValues}
            onSubmit={({ licensePeriod, ...values }) =>
              updateOrder({
                variables: { input: { _id: +id, ...values } }
              }).then(() => {
                toast({ description: "Order is updated successfully." });
                navigate("/order-management");
              })
            }
          />
        )}
      </Wrapper>
    </>
  );
};

export default Edit;
